import { FieldBase } from './base/field-base';

export class Field extends FieldBase { }